import React from 'react';

import StatusPanel from '../StatusPanel';

interface IProjectImportProps {
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const ProjectImport: React.FC<IProjectImportProps> = ({ visible, loading, onClose }) => {
  return <StatusPanel.LoadingPanel group="Project: Import" loading={loading} visible={visible} onClose={onClose} />;
};

export default ProjectImport;
